import React from "react";
import TableLoaderEffect from "../../../constant/TableLoader";
const maxWidthStyle300 = {
  maxWidth: "30rem",
  minWidth: "10rem",
  whiteSpace: "normal",
  display: "block",
};

const ProjectReportTable = ({
  selectedManuals,
  data,
  isLoading,
  toggleCheckbox,
  handleSelectAll,
  navigate,
}) => {
  return (
    <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
      <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
        <table
          id="empoloyees-tblwrapper"
          className="table ItemsCheckboxSec dataTable no-footer mb-0"
        >
          <thead>
            <tr>
              <th>
                <div className="form-check custom-checkbox checkbox-primary">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={
                      selectedManuals.length === data.length &&
                      data.length !== 0
                    }
                    onChange={handleSelectAll}
                  />
                </div>
              </th>
              <th>PR Number</th>
                  <th>Description</th>
                  <th>Supplier</th>
                  <th>Capacity</th>
                  <th>Year</th>
                  <th>Status</th>
                  <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <TableLoaderEffect colLength={7} />
            ) : (
              data.map((item, index) => (
                <tr key={index}>
                  <td>
                    <div className="form-check custom-checkbox checkbox-primary">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={selectedManuals.includes(item.id)}
                        onChange={() => toggleCheckbox(item.id)}
                      />
                    </div>
                  </td>
                  <td>
                        <span
                         onClick={() => navigate(`/documents/${item.id}`)}
                          className="text-primary cursor-pointer fw-bolder"
                        >
                          {item.manual_no}
                        </span>
                      </td>
                      <td>
                        <span style={maxWidthStyle300}>
                          
                          {item.description}
                        </span>
                      </td>
                      <td>{item.supplier}</td>
                      <td>{item.capacity}</td>
                      <td>{item.year}</td>
                      <td>
                        {item.is_approved === true ? (
                          <span
                            className={`badge light border-0 badge-success badge-sm`}
                          >
                            Approved
                          </span>
                        ) : (
                          <span
                            className={`badge light border-0 badge-info badge-sm`}
                          >
                            Pending
                          </span>
                        )}
                      </td>
                      <td>
                        <span style={maxWidthStyle300}>
                          
                          {item.remarks}
                        </span>
                      </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProjectReportTable;
